import { ILogin } from "@/interfaces";
import NetworkService, { Endpoint } from "./NetworkService";
import { useMainStore } from "@/store";
import UserService from "./UserService";


export default class AuthService extends NetworkService {
    constructor() {
        super();
    }

    login = async (params: ILogin) => {
        const res = await this.post(Endpoint.login, params);
        if (res.data.type === "pharmacy") {
            return await this.prepareSession(res);
        } else {
            throw { status: false, message: res.message || "Credenciais inválidas" };
        }
    };

    prepareSession = async (res: any) => {
        const store = useMainStore()
        if (res.access_token) {
            store.saveToken(res.access_token)
        }
        const user = await new UserService().show(res.data.id)
        store.saveSession(user.data)
        return res
    }

    logout = async () => {
        const store = useMainStore()
        store.clearSession()
    }

    passwordRecovery = (email: string) => {
        return this.post(Endpoint.passwordRecovery, { email })
    }

}